'use strict';

var Css = require("bs-css-dom/src/Css.js");
var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var React = require("react");
var Chunk$Genetics = require("./Chunk.bs.js");

function decideColor(param) {
  switch (param) {
    case "A" :
        return Css.red;
    case "C" :
        return Css.green;
    case "G" :
        return Css.blue;
    case "T" :
    case "U" :
        return Css.yellow;
    default:
      return Css.white;
  }
}

function toggle(base, param) {
  if (param) {
    return decideColor(base);
  } else {
    return Css.white;
  }
}

function color(base, color_on) {
  return Css.style(/* :: */[
              Css.color(toggle(color_on, base)),
              /* [] */0
            ]);
}

var Styles = {
  decideColor: decideColor,
  toggle: toggle,
  color: color
};

function StyledBases(Props) {
  var strand = Props.strand;
  var colorOn = Props.colorOn;
  var colorBases = function (index, bases) {
    if (bases) {
      var style = color(colorOn, bases[0]);
      var key = String(index);
      var content = $$Array.of_list(bases).join("");
      return React.createElement("span", {
                  key: key,
                  style: style
                }, content);
    } else {
      return "";
    }
  };
  var bases = function (param) {
    return Chunk$Genetics.group_by_order(undefined, (function (x, y) {
                  return x === y;
                }), $$Array.to_list(strand.split("")));
  };
  var styled = function (param) {
    return $$Array.of_list(List.mapi(colorBases, bases(/* () */0)));
  };
  return React.createElement("p", {
              className: "base-output"
            }, colorOn ? styled(/* () */0) : strand);
}

var make = StyledBases;

exports.Styles = Styles;
exports.make = make;
/* Css Not a pure module */
